import { Box, Typography, useMediaQuery, useTheme } from '@mui/material'

import { Notification } from '@components/prereg_validation/notification'
import { useSessionContext } from '@providers/session'
import { i18WithParams as t } from '@shared/locale'
import { PurchaseHistory } from '@views/purchase_history'

export const Bookings = () => {
  const sessionCtx = useSessionContext()
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))

  return (
    <Box sx={{ width: '100%' }}>
      <Notification lupId={sessionCtx.state.user?.lupId || ''} />

      <Typography variant="h2" sx={{ mb: 2 }} pl={isBelowMD ? 2 : 0}>
        {t('profile.bookings.title')}
      </Typography>
      <PurchaseHistory />
    </Box>
  )
}
